/*
 *  Video Reviews Carousel
 *    Scripts for the video reviews carousel
 *
 *  Version:
 *    1.0.0 - 2022/02/17
 */

import {
  initCarousel,
  CarouselOptions,
  InitCarouselParams,
} from '../../objects/carousel';
import { CLASS_INITIALISED } from '../../tools/constants/classes';

// Selectors
const SELECTOR_SECTION = '[data-featured-reviews]';
const SELECTOR_CAROUSEL = '[data-featured-reviews-carousel]';
const SELECTOR_SLIDE = '[data-featured-reviews-slide]';
const SELECTOR_NAVIGATION = '[data-carousel-navigation]';
const SELECTOR_DOTS_CAROUSEL = '[data-carousel-dots]';

document
  .querySelectorAll<HTMLElement>(SELECTOR_SECTION)
  .forEach((container) => {
    // Check if section has already been initialized
    if (container.classList.contains(CLASS_INITIALISED)) return;
    container.classList.add(CLASS_INITIALISED);

    const carousel = container.querySelector<HTMLElement>(SELECTOR_CAROUSEL);
    const slide = container.querySelector<HTMLElement>(SELECTOR_SLIDE);
    const navigation =
      container.querySelector<HTMLElement>(SELECTOR_NAVIGATION);
    const dotsContainer = container.querySelector<HTMLElement>(
      SELECTOR_DOTS_CAROUSEL
    );

    if (!carousel || !navigation || !dotsContainer) return;

    // Set carousel options
    const options: CarouselOptions = {
      slidesPerView: 1,
      loop: true,
      centered: true,
      duration: 1000,
    };

    // Set carousel parameters
    const params: InitCarouselParams = {
      container: carousel,
      navigationContainer: navigation,
      dotsContainer,
      options,
    };

    // Initialize carousel
    initCarousel(params);
  });
